import React, { useContext } from 'react'
import { PageMeta } from 'components/Layout/Page'
import { TaskBar, List, ThemeProvider, Frame, Modal } from '@react95/core'
import { Computer, Progman21 } from '@react95/icons'
import { useHistory } from 'react-router-dom'
import { Text, useMatchBreakpoints, Heading } from '@pancakeswap/uikit'
import { arcadeGames } from 'config/constants/arcadeGames'
import { AutoRow } from 'components/Layout/Row'
import { ArcadeContext } from 'Providers'
import { useTranslation } from 'contexts/Localization'
import { TokenAmount } from '@pancakeswap/sdk'
import { useWeb3React } from '@web3-react/core'
import tokens from 'config/constants/tokens'
import { useTokenBalances } from 'state/wallet/hooks'
import GameIcon from './components/GameIcon'
import GameModal from './components/GameModal'

export default function Games() {
  const history = useHistory()
  const { t } = useTranslation()
  const { currentGame, setCurrentGame } = useContext(ArcadeContext)
  const { isMobile } = useMatchBreakpoints()
  const { account } = useWeb3React()
  const balances = useTokenBalances(account, [tokens.bnb, tokens.busd, tokens.windoge95])
  const windogeBalance: undefined | TokenAmount = balances?.[tokens.windoge95.address]
  const modalFrameStyle: any = {
    minWidth: '60%',
    minHeight: '100%',
    backgroundColor: 'white',
    overflowY: 'scroll',
    maxHeight: isMobile ? '430px' : '530px',
    padding: '8px',
  }
  const modalStyle: any = {
    margin: '16px',
    height: '60%',
    width: '60%',
    minWidth: '60%',
    minHeight: '400px',
    maxWidth: '400px',
    maxHeight: isMobile ? '500px' : '500px',
  }
  const iconStyle: any = { height: '35px', width: '35px', borderRadius: '4px' }

  const hasAccess =
    account &&
    (account === '0x68D30fb410Bef5f122FAbbf6d5b4aC60827bf797' ||
      (windogeBalance && Number.parseFloat(windogeBalance?.toFixed(9)) >= 10000))

  return (
    <>
      <style>
        {` 
          body {
            background-color: #008080;
            background-image: url(https://uploads-ssl.webflow.com/618355b75eeec9b5cc079e5c/61934152bfe13650b9148d21_DesktopBG.jpeg);
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            background-attachment: fixed;
          }
      `}
      </style>
      <ThemeProvider>
        <PageMeta />
        {!hasAccess && (
          <Modal
            defaultPosition={{ x: 12, y: 12 }}
            icon={<Progman21 />}
            title="Games"
            width="50vw"
            height="50vh"
            closeModal={null}
            style={modalStyle}
          >
            <Frame style={modalFrameStyle}>
              <Heading scale="xl" mb="16px" mt="16px">
                {t(`Games`)}
              </Heading>
              <Text fontSize="18px" mb="24px">
                {t(`In order to play games on Windoge95, you must hold at least 10,000 tokens.`)}
              </Text>
            </Frame>
          </Modal>
        )}

        {currentGame && hasAccess && <GameModal />}
        {hasAccess && (
          <AutoRow align="flex-start">
            {Object.keys(arcadeGames).map((g) => {
              return <GameIcon game={arcadeGames[g]} />
            })}
          </AutoRow>
        )}
        <TaskBar
          list={
            <List>
              {hasAccess ? (
                Object.keys(arcadeGames).map((g) => {
                  return (
                    <List.Item
                      icon={<img src={arcadeGames[g].imgSrc} alt="" style={iconStyle} loading="lazy" />}
                      onClick={() => setCurrentGame(arcadeGames[g])}
                    >
                      {arcadeGames[g].title}
                    </List.Item>
                  )
                })
              ) : (
                <></>
              )}
              <List.Item icon={<Computer variant="32x32_4" />} onClick={() => history.goBack()}>
                Back
              </List.Item>
            </List>
          }
        />
      </ThemeProvider>
    </>
  )
}
